module.exports = __webpack_public_path__ + "static/media/Bayan_logo.cf5a24cc.png";